import Icon from "@mui/icons-material/LocalShipping";
import FmbThaliDistributorCreate from "./FmbThaliDistributorCreate";
import FmbThaliDistributorEdit from "./FmbThaliDistributorEdit";
import FmbThaliDistributorList from "./FmbThaliDistributorList";

export default {
  list: FmbThaliDistributorList,
  create: FmbThaliDistributorCreate,
  edit: FmbThaliDistributorEdit,
  icon: Icon,
  label: "Thali distributors",
  options: { label: "Thali distributors" },
  name: "fmbThaliDistributor",
};
